// ============================================================
// DISPATCH ALARM UTILITY - Retours SAC
// ------------------------------------------------------------
// Alarme sonore reutilisable pour signaler l'arrivee d'un
// nouveau retour SAC (stop avec status='retourne') dans la
// Grille Commandes. Utilise /alarm.wav dans public/.
// Deverrouille automatiquement l'audio au premier geste
// utilisateur (policy des navigateurs mobiles).
// ============================================================

let dispatchAlarmAudio = null;
let dispatchAudioUnlocked = false;

const getDispatchAlarmAudio = () => {
  if (!dispatchAlarmAudio) {
    dispatchAlarmAudio = new Audio('/alarm.wav');
    dispatchAlarmAudio.preload = 'auto';
    dispatchAlarmAudio.volume = 1.0;
  }
  return dispatchAlarmAudio;
};

// Deverrouille l'audio au 1er clic/tap
if (typeof window !== 'undefined') {
  const events = ['click', 'touchstart', 'touchend', 'keydown'];
  const handler = () => {
    if (dispatchAudioUnlocked) return;
    const a = getDispatchAlarmAudio();
    a.volume = 0.01;
    const p = a.play();
    if (p && p.then) {
      p.then(() => {
        a.pause();
        a.currentTime = 0;
        a.volume = 1.0;
        dispatchAudioUnlocked = true;
        events.forEach(e => document.removeEventListener(e, handler, true));
      }).catch(() => {});
    }
  };
  events.forEach(e => document.addEventListener(e, handler, true));
}

export const playDispatchAlarm = () => {
  try {
    const a = getDispatchAlarmAudio();
    a.volume = 1.0;
    a.currentTime = 0;
    const p = a.play();
    if (p && p.then) p.catch(err => console.warn('Dispatch alarm blocked:', err));
  } catch (e) {
    console.warn('Could not play dispatch alarm:', e);
  }
};

// Extrait les IDs des arrets 'retourne' d'une liste de commandes
export const extractReturnedStopIds = (orders) => {
  const ids = new Set();
  (orders || []).forEach(o => {
    (o.stops || []).forEach(s => {
      if (s.status === 'retourne' || s.block_status === 'retourne') {
        ids.add(s.id);
      }
    });
  });
  return ids;
};
